import { Trophy, UserPlus } from "lucide-react";

function initials(name) {
  return (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("") || "?";
}

export function TopReferrersMini({ referrers }) {
  const rows = referrers || [];
  return (
    <div
      className="rounded-2xl border border-gray-100 bg-white p-6 shadow-mb-card"
      data-testid="admin-top-referrers"
    >
      <div className="inline-flex items-center gap-1.5 rounded-full border border-brand-navy/15 bg-brand-navy/5 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-brand-navy">
        <Trophy className="h-3 w-3" />
        Top 5 referrers
      </div>
      <h3 className="mt-3 text-xl font-bold tracking-tight text-gray-900">
        Network amplifiers
      </h3>
      <p className="mt-1 text-xs text-gray-500">
        Brokers ranked by verified downstream sign-ups.
      </p>

      {rows.length === 0 ? (
        <div
          className="mt-6 rounded-xl border border-dashed border-gray-200 bg-gray-50 p-6 text-center text-sm text-gray-500"
          data-testid="admin-top-referrers-empty"
        >
          No verified referrals yet.
        </div>
      ) : (
        <ol className="mt-5 space-y-3" data-testid="admin-top-referrers-list">
          {rows.map((r, i) => (
            <li
              key={r.id}
              className="flex items-center gap-3 rounded-xl border border-gray-100 bg-gray-50 p-3"
              data-testid={`top-referrer-row-${i + 1}`}
            >
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-brand-navy text-xs font-bold text-white tabular-nums">
                {i + 1}
              </span>
              <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-white text-[11px] font-bold text-brand-navy ring-1 ring-gray-200">
                {initials(r.full_name)}
              </div>
              <div className="min-w-0 flex-1">
                <div
                  className="truncate text-sm font-semibold text-gray-900"
                  data-testid={`top-referrer-name-${i + 1}`}
                >
                  {r.full_name || r.email}
                </div>
                <div className="mt-0.5 truncate text-[11px] text-gray-500 font-mono">
                  {r.referral_code}
                </div>
              </div>
              <span
                className="inline-flex flex-none items-center gap-1 rounded-full bg-brand-green/10 px-2.5 py-1 text-xs font-bold text-brand-green tabular-nums"
                data-testid={`top-referrer-count-${i + 1}`}
              >
                <UserPlus className="h-3 w-3" />
                {r.verified_count}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
